import { render, staticRenderFns } from "./verdaderoFalso.vue?vue&type=template&id=13bf34d4&scoped=true&"
import script from "./verdaderoFalso.vue?vue&type=script&lang=js&"
export * from "./verdaderoFalso.vue?vue&type=script&lang=js&"
import style0 from "./verdaderoFalso.vue?vue&type=style&index=0&id=13bf34d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf34d4",
  null
  
)

export default component.exports